import {ReportingTrackersParams} from 'src/app/core/model/reporting';

export function getParamsKey(params: ReportingTrackersParams): string {
  return `${params.projectId}${params.startDate}${params.endDate}`;
}
